import { blueberryFeatureConfig } from './blueberry/configs/blueberryConfig';
import { AIServiceConfigs, AIServiceDefinition } from './types';

/**
 * This enum contains the names of all Services
 */
export enum AIServiceEnum {
  blueberry = 'blueberry',
  bud = 'bud',
  cluster_berry = 'cluster_berry',
  growth_nogrowth = 'growth_nogrowth',
  inflorescence = 'inflorescence',
  inflorescence_juice = 'inflorescence_juice',
  leaf = 'leaf',
  node = 'node',
  shoot = 'shoot',
}

/**
 * This enum contains the names of all Classes
 */
export enum AIClassEnum {
  berry = 'berry',
  berry_cluster = 'berry_cluster',
  blueberry = 'blueberry',
  blueberry_Blue = 'blueberry_Blue',
  blueberry_Green = 'blueberry_Green',
  blueberry_Purple = 'blueberry_Purple',
  blueberry_Yellow = 'blueberry_Yellow',
  bud = 'bud',
  cluster = 'cluster',
  cluster_pick_later = 'cluster_pick_later',
  cluster_pick_never = 'cluster_pick_never',
  cluster_pick_now = 'cluster_pick_now',
  flower = 'flower',
  flower_closed = 'flower_closed',
  flower_open = 'flower_open',
  flower_petalfall = 'flower_petalfall',
  growth = 'growth',
  growth_nogrowth = 'growth_nogrowth',
  inflorescence = 'inflorescence',
  leaf = 'leaf',
  node = 'node',
  nogrowth = 'nogrowth',
  shoot = 'shoot',
}

/**
 * A skeleton object to eventually contain all service configs
 */
export const ServiceConfigs: AIServiceConfigs = {
  [AIServiceEnum.blueberry]: blueberryFeatureConfig,
  [AIServiceEnum.bud]: {},
  [AIServiceEnum.cluster_berry]: {},
  [AIServiceEnum.growth_nogrowth]: {},
  [AIServiceEnum.inflorescence]: {},
  [AIServiceEnum.inflorescence_juice]: {},
  [AIServiceEnum.leaf]: {},
  [AIServiceEnum.node]: {},
  [AIServiceEnum.shoot]: {},
};

// FIXME Below object is currently just a data reference, and not used anywhere in code
export const ServiceDefinitions: {
  [key in AIServiceEnum]: AIServiceDefinition[];
} = {
  [AIServiceEnum.blueberry]: [
    {
      version: '1',
      classes: [
        { name: AIClassEnum.blueberry },
        { name: AIClassEnum.blueberry_Blue },
        { name: AIClassEnum.blueberry_Green },
        { name: AIClassEnum.blueberry_Purple },
        { name: AIClassEnum.blueberry_Yellow },
      ],
    },
    {
      version: '2',
      classes: [
        { name: AIClassEnum.blueberry },
        { name: AIClassEnum.blueberry_Blue },
        { name: AIClassEnum.blueberry_Green },
        { name: AIClassEnum.blueberry_Purple },
        { name: AIClassEnum.blueberry_Yellow },
      ],
    },
    {
      version: '3',
      classes: [
        { name: AIClassEnum.blueberry },
        { name: AIClassEnum.blueberry_Blue },
        { name: AIClassEnum.blueberry_Green },
        { name: AIClassEnum.blueberry_Purple },
        { name: AIClassEnum.blueberry_Yellow },
      ],
    },
    {
      version: '4',
      classes: [
        { name: AIClassEnum.blueberry },
        { name: AIClassEnum.blueberry_Blue },
        { name: AIClassEnum.blueberry_Green },
        { name: AIClassEnum.blueberry_Purple },
        { name: AIClassEnum.blueberry_Yellow },
      ],
    },
    {
      version: '5',
      classes: [
        { name: AIClassEnum.blueberry },
        { name: AIClassEnum.blueberry_Blue },
        { name: AIClassEnum.blueberry_Green },
        { name: AIClassEnum.blueberry_Purple },
        { name: AIClassEnum.blueberry_Yellow },
      ],
    },
    {
      version: '6',
      classes: [
        { name: AIClassEnum.blueberry },
        { name: AIClassEnum.blueberry_Blue },
        { name: AIClassEnum.blueberry_Green },
        { name: AIClassEnum.blueberry_Purple },
        { name: AIClassEnum.blueberry_Yellow },
        { name: AIClassEnum.flower },
      ],
    },
    {
      version: '6fit',
      classes: [
        { name: AIClassEnum.blueberry },
        { name: AIClassEnum.blueberry_Blue },
        { name: AIClassEnum.blueberry_Green },
        { name: AIClassEnum.blueberry_Purple },
        { name: AIClassEnum.blueberry_Yellow },
        { name: AIClassEnum.flower },
      ],
    },
    {
      version: '7',
      classes: [
        { name: AIClassEnum.blueberry },
        { name: AIClassEnum.blueberry_Blue },
        { name: AIClassEnum.blueberry_Green },
        { name: AIClassEnum.blueberry_Purple },
        { name: AIClassEnum.blueberry_Yellow },
        { name: AIClassEnum.flower_open },
        { name: AIClassEnum.flower_closed },
        { name: AIClassEnum.flower_petalfall },
        { name: AIClassEnum.flower },
      ],
    },
  ],
  [AIServiceEnum.bud]: [],
  [AIServiceEnum.cluster_berry]: [],
  [AIServiceEnum.growth_nogrowth]: [],
  [AIServiceEnum.inflorescence]: [],
  [AIServiceEnum.inflorescence_juice]: [],
  [AIServiceEnum.leaf]: [],
  [AIServiceEnum.node]: [],
  [AIServiceEnum.shoot]: [],
};
